<template>
  <div class="pricing-page">
    <div id="hero">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column is-8 is-offset-2 has-text-centered">
            <h1
              class="title-wide is-0 text color-white mb-2"
              v-html="title"
            />
          </div>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3 has-text-centered">
            <p class="text xl is-2 text color-white mb-0">
              Each of our plans gives you unlimited downloads from our catalogue of cutting edge
              artists. Thousands of tracks &amp; SFX to choose from, updated weekly.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="gutter">
        <div
          id="table"
          class="columns is-centered mb-6"
        >
          <div class="column is-9-tablet is-11-desktop is-9-widescreen">
            <div class="is-left-right mb-5">
              <b-switch
                v-model="showYearly"
                class="ml-0 is-left-right is-accent"
                type="is-danger"
              >
                {{ intervalSwitchText }}
              </b-switch>
            </div>
            <div class="is-clearfix" />
            <pricing-plan-card-list
              class="text"
              :plans="sortedPlans"
            />
          </div>
        </div>
      </div> <!-- /.gutter -->
    </div> <!-- /.container -->

    <div
      v-if="sortedProducts.length > 0"
      class="container"
    >
      <div class="gutter">
        <div class="columns is-centered">
          <div class="column is-9 single-use-license">
            <div class="card-content">
              <p class="text title-lowercase is-4 color-white">
                Track licenses can also be purchased individually.
              </p>
              <div class="columns">
                <div
                  v-for="product in sortedProducts"
                  :key="product.pk"
                  class="column"
                >
                  <h3 class="text extra-large color-white">
                    {{ product.name }}
                  </h3>
                  <h3 class="text title-lowercase is-5 color-white mb-0">
                    {{ product.amount|formattedDbAmount(currencySymbol, 0) }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="gutter">
        <div class="columns is-centered mt-6">
          <div class="column is-9">
            <h3 class="text title-wide is-2 mb-4">
              Frequently asked questions
            </h3>
            <faq-list />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PricingPlanCardList from '@/components/PricingPlanCardList.vue'
import FAQList from '@/components/FAQList.vue'

export default {
  name: 'PricingPage',

  components: {
    PricingPlanCardList,
    'faq-list': FAQList
  },

  data () {
    return {
      showYearly: false
    }
  },

  computed: {
    isLoggedIn: function () {
      return this.$store.getters['auth/isLoggedIn']
    },

    sortedPlansMonthly: function () {
      const plans = [...this.$store.getters['subscriptions/plans']].filter((plan) => plan.interval === 'month')
      return plans.sort((a, b) => a.amount - b.amount)
    },

    sortedPlansYearly: function () {
      const plans = [...this.$store.getters['subscriptions/plans']].filter((plan) => plan.interval === 'year')
      return plans.sort((a, b) => a.amount - b.amount)
    },

    sortedPlans: function () {
      if (this.showYearly) {
        return this.sortedPlansYearly
      } else {
        return this.sortedPlansMonthly
      }
    },

    sortedProducts: function () {
      const products = [...this.$store.getters['cart/products']]
      return products.sort((a, b) => a.amount - b.amount)
    },

    currencySymbol: function () {
      // WARNING: Assuming that all products have the same currency.
      if (this.$store.getters['cart/products'].length > 0) {
        return this.$store.getters['cart/products'][0].currency.symbol
      }
      return ''
    },

    trialMode: function () {
      return this.$store.getters['subscriptions/createSubscriptionWithTrial']
    },

    title: function () {
      if (this.trialMode) {
        return 'Start your 30-day free trial'
      }
      return 'Subscriptions'
    },

    selectButtonText: function () {
      if (this.trialMode) {
        return 'Start free trial'
      }
      return 'Select'
    },

    intervalSwitchText: function () {
      if (this.showYearly) {
        return 'Show monthly'
      } else {
        return 'Get two months free when paid yearly'
      }
    }
  },

  metaInfo: {
    title: 'Pricing | Music Licensing',
    meta: [
      { name: 'description', content: 'Simple Pricing. Personal/Professional/Advertising. All licenses cover global distribution in perpetuity.' }
    ]
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/_variables.scss";
p.intro {
  color: $grey-lighter;
}
</style>
